//ユーザーCSVアップロードページ
import React, { Fragment, useState } from 'react';
import { Typography, Button, Form, message, Input, Select, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import Dropzone from 'react-dropzone';
import Axios from 'axios';
import config from '../../Config/key';
import Papa from 'papaparse';
import {
  decodeCsvBuffer,
  validateCsvHeaders,
  formatHeaderValidationError,
  extractAxiosErrorMessage,
} from '../../../utils/csvUploadHelper';
// const bcrypt = require('bcrypt');
// const saltRounds = 10;
const { Option } = Select;
const { TextArea } = Input;
const { Title, Text } = Typography;

// CSV に必須の列（email のみ）
const REQUIRED_COLUMNS = ['email'];

function CSVTokenInsertPage(props) {
  const [fileData, setFileData] = useState();
  const [fileJSON, setFileJSON] = useState();
  const [groups, setGroups] = useState([]); //グループ名とグループコード
  const [selSurveySeasonId, setSelSurveySeasonId] = useState([]); //選択したシーズンID
  const [selSurveySeasonInfo, setSelSurveySeasonInfo] = useState([]); //選択したシーズン情報
  const [surveySeason, setSurveySeason] = useState([]); //グループにあるサーベイシーズン
  const [questionSet, setQuestionSet] = useState([]); //全てのサーベイ情報
  const [selQuestionSetId, setSelQuestionSetId] = useState(null); //全てのサーベイ情報

  // let department = [];

  // const [projectDescriptionValue, setProjectDescriptionValue] = useState('');
  const [groupCode, setGroupCode] = useState('');
  const [submitButtonDisable, setSubmitButtonDisable] = useState(true);
  // 処理中フラグ（大量件数で待機が長い間、二重送信防止 + 全画面スピナー）
  const [processing, setProcessing] = useState(false);

  const onDrop = async (files) => {
    const file = files[0];
    const reader = new FileReader();
    reader.onabort = () => console.log('file reading was aborted');
    reader.onerror = () => console.log('file reading failed');
    reader.onload = (e) => {
      //ファイルの読み込みが終わったら発火
      // decodeCsvBuffer で文字コード自動判定 + 先頭 BOM 除去まで一括処理
      const unicodeString = decodeCsvBuffer(e.target.result);
      Papa.parse(unicodeString, {
        header: true,
        dynamicTyping: false,
        skipEmptyLines: true,
        complete: async (results) => {
          // 必須列の存在検証（BOM は decodeCsvBuffer で除去済み、その他不可視文字を捕捉）
          const headers = (results.meta && results.meta.fields) || [];
          const v = validateCsvHeaders(headers, REQUIRED_COLUMNS);
          if (!v.ok) {
            message.error({
              content: formatHeaderValidationError(v),
              key: 'csvupload',
              duration: 10,
            });
            setFileJSON(undefined);
            setFileData(
              'エラー：CSVヘッダーを確認の上、再アップロードしてください。'
            );
            return;
          }
          setFileData(unicodeString);
          setFileJSON(results.data);
          //const courseInfo = courseMerge(results.data);
          // setProjectKeyValue(`${courseInfo.course_id}_${ymdhms()}`);
          // console.log({ courseInfo });
        },
      });
    };
    reader.readAsArrayBuffer(file); //ファイルを読み込む
    const group = await Axios.get('/api/group/');
    setGroups(group.data.groups);
    setSubmitButtonDisable(true);
    setGroupCode('');
    setSelSurveySeasonId('');

    // console.log(group.data.groups);
  };

  //yyyymmddhhmmss
  const ymdhms = () => {
    var date = new Date();
    return (
      date.getFullYear() +
      ('0' + (date.getMonth() + 1)).slice(-2) +
      ('0' + date.getDate()).slice(-2) +
      ('0' + date.getHours()).slice(-2) +
      ('0' + date.getMinutes()).slice(-2) +
      ('0' + date.getSeconds()).slice(-2)
      // date.getMilliseconds()
    );
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    // let userData = []; //最終分類用
    setProcessing(true);
    try {
      message.loading({
        content: 'CSVアップロード中...（件数が多い場合は時間がかかります）',
        key: 'csvupload',
        duration: 0,
      });

      // CSV が正常に読み込まれているかを確認（必須列検証で弾かれた場合は fileJSON が undefined）
      if (!fileJSON || !Array.isArray(fileJSON) || fileJSON.length === 0) {
        message.error({
          content:
            '有効なCSVファイルがアップロードされていません。CSVを再確認してください。',
          key: 'csvupload',
          duration: 3,
        });
        throw new Error('CSVデータがありません。');
      }
      const res = await Axios.get('/api/users/group/' + groupCode);
      const groupUser = res.data.users;

      // email を正規化（trim + 小文字化）して企業ユーザーを索引化
      // CSV の各 email を選択企業のユーザーと突き合わせるために使用
      const normalizeEmail = (email) => (email || '').trim().toLowerCase();
      const groupUserByEmail = new Map(
        groupUser.map((item) => [normalizeEmail(item.email), item])
      );

      // 選択企業に登録されていない email を事前検出（未登録があると
      // 後段の find(...)._id で undefined 参照クラッシュになるため、ここで弾く）
      const missingEmails = [];
      fileJSON.forEach((record) => {
        if (!groupUserByEmail.has(normalizeEmail(record.email))) {
          missingEmails.push(record.email);
        }
      });
      if (missingEmails.length > 0) {
        message.error({
          content:
            '次のメールアドレスは選択した企業に登録されていません。先にユーザー登録を行ってください：' +
            missingEmails.join('、'),
          key: 'csvupload',
          duration: 10,
        });
        throw new Error('企業に未登録のユーザーが含まれています。');
      }

      let sendData = [];
      let tempData = {};
      let sendToken = [];
      let tempToken = {};
      let boss = [];
      let partner = [];
      // for (let index = 0; index < fileJSON.length; index++) {
      //   const record = fileJSON[index];
      //   switch (record.relation) {
      //     case 1:
      //       if (tempData) {
      //         tempData.boss = boss;
      //         tempData.partner = partner;
      //         sendData.push(tempData);
      //         tempData = {};
      //         boss = [];
      //         partner = [];
      //       }
      //       tempData = {
      //         survey_season_id: selSurveySeasonId,
      //         user_id: groupUser.find((item) => item.email === record.email)
      //           ._id,
      //       };
      //       break;

      //     case 2:
      //       boss.push(
      //         groupUser.find((item) => item.email === record.email)._id
      //       );
      //       break;

      //     case 3:
      //       partner.push(
      //         groupUser.find((item) => item.email === record.email)._id
      //       );
      //       break;

      //     default:
      //       break;
      //   }
      //   console.log({ record });
      // }

      //本人が本人の協力者に登録しないようにする。
      // let hero = '';
      // fileJSON.forEach((element) => {
      //   if (element.relation === 1) {
      //     hero = element.email;
      //   }
      //   if (
      //     (element.relation === 2 || element.relation === 3) &&
      //     element.email === hero
      //   ) {
      //     throw new Error('本人が協力者の中に入っています。');
      //   }
      // });

      //Upload Fileの本人email
      // let heroEmail = fileJSON
      //   .filter((item) => item.relation === 1)
      //   .map((item) => item.email);

      // let s = new Set(heroEmail);
      // // console.log({ s });
      // // console.log({ heroEmail });
      // if (s.size != heroEmail.length) {
      //   throw new Error('本人が重複しています。');
      // }

      //Upload Fileの「本人」のID
      // let heroId = [];
      // heroEmail.forEach((element) => {
      //   heroId.push(groupUser.find((item) => item.email === element)._id);
      // });
      //選択したシーズンに設定されている「本人」のID
      // let inHeroId = [];
      // selSurveySeasonInfo.relation_360.forEach((element) => {
      //   inHeroId.push(element.user_id);
      // });

      // console.log({ heroId });
      // console.log({ inHeroId });
      //Upload Dataの本人が同じシーズンに既に存在する場合はエラーを出す
      //新しい本人+協力者（既存含め）は追加登録可能
      // heroId.forEach((element) => {
      //   if (inHeroId.includes(element)) {
      //     throw new Error('登録対象の本人が既に存在します。');
      //   }
      // });
      // let hInfo = '';
      await fileJSON.map((record) => {
        const sendDate = new Date();
        let expire = new Date();
        expire = expire.setDate(expire.getDate() + 60);
        tempToken = {
          user: groupUserByEmail.get(normalizeEmail(record.email))._id,
          survey_id: selSurveySeasonInfo.survey_id,
          survey_code: selSurveySeasonInfo.survey_code,
          question_set_id: selQuestionSetId,
          token_make_date: sendDate,
          token_expire: expire,
          token_valid: sendDate,
          survey_status: 0,
          group_code: groupCode,
          survey_season_id: selSurveySeasonId,
        };

        //本人用設問セットのIDを取得
        //シーズン情報の中に存在する一番目の本人用設問セット
        //１シーズンでは１typeの問題セットのみがアサインされる前提(6x6,6x5,5x6,cup)
        // const hero_question = selSurveySeasonInfo.question_set.find(
        //   (item) => item.sub_type === '4'
        // )._id;
        //協力者用設問セットのIDを取得
        //シーズン情報の中に存在する一番目の協力者用設問セット
        //１シーズンでは１typeの問題セットのみがアサインされる前提(6x6,6x5,5x6,cup)
        // const around_question = selSurveySeasonInfo.question_set.find(
        //   (item) => item.sub_type === '5'
        // )._id;

        //   switch (record.relation) {
        //     case 1: //本人の場合
        //       if (tempData.survey_season_id) {
        //         //次の本人になった場合
        //         tempData.boss = boss;
        //         tempData.partner = partner;
        //         sendData.push(tempData);
        //         tempData = {};
        //         boss = [];
        //         partner = [];
        //       }
        //       //本人データの格納
        //       hInfo = groupUser.find((item) => item.email === record.email);
        //       // console.log({ hInfo });
        //       tempData = {
        //         survey_season_id: selSurveySeasonId,
        //         user_id: hInfo._id,
        //         group_code: groupCode,
        //       };
        //       tempToken.question_set_id = hero_question;
        //       tempToken.hero_id = hInfo._id;
        //       tempToken.hero_name = hInfo.lastname + ' ' + hInfo.name;
        //       tempToken.relation = 1;
        //       break;

        //     case 2: //上司の場合
        //       boss.push(
        //         groupUser.find((item) => item.email === record.email)._id
        //       );
        //       tempToken.question_set_id = around_question;
        //       tempToken.hero_id = hInfo._id;
        //       tempToken.hero_name = hInfo.lastname + ' ' + hInfo.name;
        //       tempToken.relation = 2;
        //       break;

        //     case 3: //部下・同僚の場合
        //       partner.push(
        //         groupUser.find((item) => item.email === record.email)._id
        //       );
        //       tempToken.question_set_id = around_question;
        //       tempToken.hero_id = hInfo._id;
        //       tempToken.hero_name = hInfo.lastname + ' ' + hInfo.name;
        //       tempToken.relation = 3;
        //       break;

        //     default:
        //       break;
        //   }
        sendToken.push(tempToken);
      });
      // tempData.boss = boss;
      // tempData.partner = partner;
      // sendData.push(tempData);

      // console.log({ sendData });
      // console.log({ sendToken });
      // console.log({ selSurveySeasonInfo });
      // console.log({ userData });
      // console.log({ department });

      // const res3 = await Axios.post('/api/relation360', sendData);

      const res3 = await Axios.post('/api/surveyToken/ticket', sendToken);
      // Axios.post('/api/relation360', sendData),

      if (res3.data.success) {
        // if (0) {
        setFileData('CSVアップロードが完了しました。');
        message.success({
          content: 'アップロード完了！',
          key: 'csvupload',
          duration: 3,
        });
        setTimeout(() => {
          props.history.push('/');
        }, 1000);
      } else {
        message.error({
          content: 'CSVアップロードに失敗しました。',
          key: 'csvupload',
          duration: 3,
        });
        throw new Error('CSVアップロードに失敗しました。');
      }
    } catch (error) {
      console.log({ error });
      /*
      ＜課題＞
      projectKeyがUniqueでない場合の処理を追加
      MongoDB error code 11000
      */
      // バックエンドの具体的なエラー本文を抽出して表示（運用担当が pm2 logs 参照不要）
      message.error({
        content: extractAxiosErrorMessage(
          error,
          'CSVアップロードに失敗しました。'
        ),
        key: 'csvupload',
        duration: 5,
      });
    } finally {
      setProcessing(false);
    }
  };

  const onChangeGroup = (value) => {
    if (value) {
      setGroupCode(value);
      setSubmitButtonDisable(true);
      const ssi = groups.find(
        (item) => item.group_code === value
      ).survey_season;
      setSurveySeason(ssi);
      setSelSurveySeasonId('');
      setSelQuestionSetId(null);
      setQuestionSet([]);
      // console.log({ ssi });
    }
    // console.log(e);
  };

  const onChangeSurveySeason = (value) => {
    if (value) {
      const sssi = surveySeason.find((item) => item._id === value);
      setSelSurveySeasonId(value);
      setSelSurveySeasonInfo(sssi);
      setSubmitButtonDisable(false);
      setQuestionSet(sssi.question_set);
      if (sssi.question_set.length > 0) {
        setSelQuestionSetId(sssi.question_set[0]._id);
      } else {
        setSelQuestionSetId(null);
      }
      // console.log({ value });
    }
  };

  const onChangeQuestionSet = async (value) => {
    // console.log({ value });
    setSelQuestionSetId(value);
  };

  return (
    <Fragment>
      <Spin
        spinning={processing}
        fullscreen
        tip="処理中です。完了までこのままお待ちください…"
      />
      <div style={{ maxWidth: '700px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>サーベイチケット CSV 発行</Title>
        </div>
        <Form onSubmit={onSubmit}>
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❶</Title>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* Drop zone */}
            <Dropzone onDrop={onDrop} multiple={false} maxSize={1000000000}>
              {({ getRootProps, getInputProps }) => (
                <div
                  style={{
                    width: '300px',
                    height: '240px',
                    border: '1px solid lightgray',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  {...getRootProps()}
                >
                  <input {...getInputProps()} />
                  <PlusOutlined style={{ fontSize: '3rem' }} />
                </div>
              )}
            </Dropzone>
            <div
              style={{
                width: '300px',
                height: '240px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Text mark>
                CSVファイルをDrag &
                Dropするか、+を押してファイルを選択してください。
              </Text>
            </div>
          </div>
          <br />
          <div>
            <Title style={{ color: 'var(--brand-primary)' }}>❷</Title>
            {/* <Text strong>企業コードを入力してください（必須）</Text>
            <Input
              placeholder="一意になる企業コードを入力してください。"
              allowClear
              onChange={onChangeGroupCode}
              value={groupCode}
            /> */}
            <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>企業を選択してください。（必須）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 10, width: 300 }}
                placeholder="企業選択"
                optionFilterProp="children"
                onChange={onChangeGroup}
                value={groupCode}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {groups.map((element) => {
                  // console.log({ element });
                  return (
                    <Option value={element.group_code} key={element._id}>
                      {element.group_name}
                    </Option>
                  );
                })}
              </Select>
            </div>
            <br />
          </div>
          <br />
          <br />
          <div>
            <Title style={{ color: 'var(--brand-primary)' }}>❸</Title>
            {/* <Text strong>企業コードを入力してください（必須）</Text>
            <Input
              placeholder="一意になる企業コードを入力してください。"
              allowClear
              onChange={onChangeGroupCode}
              value={groupCode}
            /> */}
            <Text strong>サーベイシーズンを選択してください。（必須）</Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 10, width: 300 }}
                placeholder="サーベイシーズン選択"
                optionFilterProp="children"
                onChange={onChangeSurveySeason}
                value={selSurveySeasonId}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {surveySeason.map((element) => {
                  if (element.survey_code != '40010') {
                    return (
                      <Option value={element._id} key={element._id}>
                        {element.season_name}
                      </Option>
                    );
                  } else {
                    return;
                  }
                  // console.log({ element });
                })}
              </Select>
              {questionSet.length > 0 && (
                <span>
                  設問セット
                  <Select
                    showSearch
                    style={{ marginLeft: 5, marginRight: 5, width: 300 }}
                    placeholder="設問セット選択"
                    optionFilterProp="children"
                    onChange={onChangeQuestionSet}
                    value={selQuestionSetId}
                    defaultValue={questionSet[0].set_name}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {questionSet.map((element) => {
                      return (
                        <Option value={element._id} key={element._id}>
                          {element.set_name}
                        </Option>
                      );
                    })}
                  </Select>
                </span>
              )}
            </div>
            <br />
          </div>
          <br />
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❹</Title>
          <Button
            type="primary"
            size="large"
            onClick={onSubmit}
            disabled={submitButtonDisable || processing}
            loading={processing}
          >
            アップロード
          </Button>
        </Form>
        <TextArea rows={20} value={fileData} />
      </div>
    </Fragment>
  );
}

export default CSVTokenInsertPage;
